module.exports = __webpack_public_path__ + "img/Anmeldung_wide.94281064.jpg";